const VIEWED_MAX_COUNT = 10;

/* private functions */
const _getViewed = (req) => {
  let { viewed_products = [] } = req.session;
  if (!Array.isArray(viewed_products)) {
    viewed_products = [];
  }
  return viewed_products;
};

const _existInViewed = (req, productId) => {
  const viewed = _getViewed(req);

  return viewed.some((viewedItem) => viewedItem.product_id === productId);
};

const _removeFromViewed = (req, productId) => {
  const findedIndex = _getViewed(req).findIndex(
    (viewedItem) => viewedItem.product_id === productId,
  );
  if (findedIndex !== -1) {
    req.session.viewed_products.splice(findedIndex, 1);
  }
};

const _addViewed = (req, productId, menuId) => {
  if (_existInViewed(req, productId)) {
    _removeFromViewed(req, productId);
  }

  let viewedProducts = _getViewed(req);
  viewedProducts.unshift({
    product_id: productId,
    menu_id: menuId,
  });
  if (viewedProducts.length > VIEWED_MAX_COUNT) {
    viewedProducts = viewedProducts.slice(0, VIEWED_MAX_COUNT);
  }
  req.session.viewed_products = viewedProducts;
  return req.session.viewed_products;
};

/**
 * Если не передан product_id и menu_id возвращает массив с информацией о просмотренных продуктах.
 * Массив отсортирован по дате просмотра. Вначале массива находятся последние просмотренные продукты.
 * Если передан product_id, то добавляет в начало массива информацию о просмотренном продукте и возращает весь массив.
 * @param req
 * @returns {Array} : {
 *   product_id: Number,
 *   menu_id: Number
 * }
 */
const viewed = (req) => {
  const { product_id, menu_id } = req.body;
  if (!product_id || !menu_id) {
    return _getViewed(req);
  }

  _addViewed(req, product_id, menu_id);
  return _getViewed(req);
};

/**
 * Получить id просмотренных товаров
 * @param req
 * @returns {Number[]}
 */
const getViewedIds = (req) =>
  _getViewed(req).map((viewedItem) => viewedItem.product_id);

function calculateNewStatuses(product) {
  const { prices } = product;
  const keys = Object.keys(prices);
  if (keys.length === 1) {
    switch (keys[0]) {
      case '1':
        product.is_delivery = true;
        break;
      case '2':
        product.is_pickup = true;
        break;
      default:
        product.is_pickup = true;
        product.is_delivery = true;
        break;
    }
  } else {
    product.is_pickup = true;
    product.is_delivery = true;
  }
  return product;
}
const prepareProducts = (products) => {
  if (!products) {
    return [];
  }
  if (!Array.isArray(products)) {
    if (products.price === null) {
      return [];
    }
    if (products.prices) calculateNewStatuses(products);
    products.promocodes = Boolean(
      products.promocodes &&
        Array.isArray(products.promocodes) &&
        products.promocodes.length,
    );
    return products;
  }
  return products
    .map((product) => {
      if (product.prices) calculateNewStatuses(product);
      product.promocodes = Boolean(
        product.promocodes &&
          Array.isArray(product.promocodes) &&
          product.promocodes.length,
      );
      return product;
    })
    .filter((product) => product.price !== null);
};

export { viewed, getViewedIds, prepareProducts };
